import BaseAction from "base/base.action";
import { ClientType } from "domain/types/client.type";
import { ClientModel } from "model/client/client.model";

/**
 * Action to select a client
 * @param client The selected client object
 * @returns Action object
 */
export const selectClientAction = (client: ClientModel) => {
  return BaseAction(ClientType.SELECT_CLIENT, { 
    selectedClient: client
  });
};

/**
 * Action to request clients from API
 * @returns Action object
 */
export const fetchClientsRequestAction = () => {
  return BaseAction(ClientType.FETCH_CLIENTS_REQUEST, null);
};

/**
 * Action for successful clients fetch
 * @param clients Array of client data
 * @returns Action object
 */
export const fetchClientsSuccessAction = (clients: ClientModel[]) => {
  return BaseAction(ClientType.FETCH_CLIENTS_SUCCESS, { clients });
};

/**
 * Action for failed clients fetch
 * @param error Error message
 * @returns Action object
 */
export const fetchClientsFailureAction = (error: string) => {
  return BaseAction(ClientType.FETCH_CLIENTS_FAILURE, { error });
};